import Vue from 'vue'
import Vuex from 'vuex'
/*import VuexPersistence from 'vuex-persist'*/

import auth from './modules/auth'
import global from './modules/global'
import configData from './modules/configData'

Vue.use(Vuex)

const strict = process.env.NODE_ENV != 'production'
/*const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})*/

const store = new Vuex.Store({
    modules: {
        auth,
        global,
    },
    strict: strict,
    //plugins: [vuexLocal.plugin]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js